export default function SpacerBlock({ block }: any) {
  return <div className={block.className || ''} style={{ height: block.size }} />;
}
